import { ItemSettingsResponse } from "../../../models/api/sift/back/api-item-settings";
import { ApiBaseBack } from "../../back/api-base-back";

export class ApiGetItemSettings extends ApiBaseBack<ItemSettingsResponse> {
  constructor(param: {
    itemId: string,
  }) {
    super(
      'GET',
      '/api/v1/itemSettings',
      'JSON',
      param,
    );
  }
}
